import { MotionExpand } from '#pplx/frontend/aether/components/Motion/MotionExpand.js';
import { MotionFade } from '#pplx/frontend/aether/components/Motion/MotionFade.js';
import { MotionResize } from '#pplx/frontend/aether/components/Motion/MotionResize.js';
import { MotionShake } from '#pplx/frontend/aether/components/Motion/MotionShake.js';
import { MotionSlide } from '#pplx/frontend/aether/components/Motion/MotionSlide.js';
/**
 * Motion namespace providing animation components for enter/exit transitions.
 *
 * Available components:
 * - Motion.Fade: Fade in/out animation
 * - Motion.Expand: Expand/collapse animation (vertical or horizontal)
 * - Motion.Resize: Animates size to match children's intrinsic size as content changes
 * - Motion.Slide: Directional slide animation (top, bottom, left, right)
 * - Motion.Shake: Horizontal shake animation to draw attention
 */
export const Motion = {
    Fade: MotionFade,
    Expand: MotionExpand,
    Resize: MotionResize,
    Shake: MotionShake,
    Slide: MotionSlide,
};
//# sourceMappingURL=index.js.map